import { render } from "./AssessmentTaxNew.vue?vue&type=template&id=2b0025a8&scoped=true"
import script from "./AssessmentTaxNew.vue?vue&type=script&lang=js"
export * from "./AssessmentTaxNew.vue?vue&type=script&lang=js"

import "./AssessmentTaxNew.vue?vue&type=style&index=0&id=2b0025a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b0025a8"]])

export default __exports__